import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import { CreateQuestionBehaviourData } from "../../services/QuestionsService";
import { GetVacancyTypeList } from "../../services/VacancyTypeServices";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { decryptDataFromArray } from "helpers/EncDec";

function CreateQuestionBehaviour() {
  const [formDataValues, setFormDataValues] = useState({});
  const [errors, setErrors] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState([
    { label: "Active", value: "1", id: "1" },
    { label: "Inactive", value: "0", id: "0" },
  ]);
  const [vacancyType, setVacancyType] = useState("");

  useEffect(() => {
    GetVacancyTypeList()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (responseData?.status) {
          let vacrr = responseData?.data?.map(item => ({
            label: item?.title,
            value: item?.id,
            id: item?.id,
          }));
          setVacancyType(vacrr);
        } else {
          setErrors("No data available");
        }
      })
      .catch(err => {
        setErrors("No data Available");
      });
  }, []);

  /* Handle Change Event */
  const handleChange = e => {
    const { name, value } = e.target;
    setFormDataValues({
      ...formDataValues,
      [name]: value,
    });
  };

  /* State Field selected value */
  const handleChangeVacancyTypeValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      vacancy_type_id: e?.value,
    }));
  };
  const handleChangeStatusValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      status: e?.id,
    }));
  };

  // Validation logic for each field
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formDataValues.ques_behav) {
      newErrors.ques_behav = "Question behaviour is required";
      isValid = false;
    }
    if (!formDataValues.vacancy_type_id) {
      newErrors.vacancy_type_id = "Please select an Position Level option";
      isValid = false;
    }
    if (!formDataValues.good) {
      newErrors.good = "Question behaviour good value is required";
      isValid = false;
    }
    if (!formDataValues.average) {
      newErrors.average = "Question behaviour average value is required";
      isValid = false;
    }
    if (!formDataValues.poor) {
      newErrors.poor = "Question behaviour poor value is required";
      isValid = false;
    }
    if (!formDataValues.status) {
      newErrors.status = "Please select an option";
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  // Submit the form data or perform other actions
  const handleSubmit = async e => {
    if (validateForm()) {
      let formData = new FormData();
      formData.append("vacancy_type_id", e?.vacancy_type_id);
      formData.append("ques_behav", e?.ques_behav);
      formData.append("good", e?.good);
      formData.append("average", e?.average);
      formData.append("poor", e?.poor);
      formData.append("sequence", e?.sequence);
      formData.append("status", e?.status);
      let fromEntriesObj = Object.fromEntries(formData);
      //console.log('Form append:', fromEntriesObj);return false;
      CreateQuestionBehaviourData(fromEntriesObj)
        .then(res => {
          if (res?.status === 200) {
            toast.success(res?.data?.message);
            window.location.href = "/question-behaviour-list";
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(err => {
          console.error("Error creating question parent:", err);
          setErrors("No data created.");
        });
    } else {
      console.error("Form has errors");
    }
  };

  if (!checkPermissionStatus("question-behaviour-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {/* <MetaTags>
          <title>Create Question Behaviour</title>
        </MetaTags> */}

        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center py-2 pt-0">
            <Col lg="6" md="6">
              <Link to="/question-behaviour-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  Create Question Behaviour
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
            <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
              <Link to="/employee-referral-list" className="btn btn-primary">
                Back To Listing
              </Link>
            </div>
          </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-3">
            <Container fluid>
              {/* <Breadcrumbs title="Question Behaviour" breadcrumbItem="Create Question Behaviour" /> */}
              <Col lg="12">
                <AvForm
                  className="outer-repeater"
                  onValidSubmit={() => {
                    handleSubmit(formDataValues);
                  }}
                >
                  <div data-repeater-list="outer-group" className="outer">
                    <div data-repeater-item className="outer">
                      {successMessage && (
                        <div class="alert alert-success" role="alert">
                          {successMessage}
                        </div>
                      )}
                      {errorMessage && (
                        <div class="alert alert-danger" role="alert">
                          {errorMessage}
                        </div>
                      )}
                      <Row>
                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ques_behav"
                              className="col-form-label"
                            >
                              Question Behaviour
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="ques_behav"
                              name="ques_behav"
                              placeholder="Question Behaviour"
                              errorMessage="Question Behaviour Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage:
                                    "Question Behaviour is required",
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage:
                                    "Question Behaviour must be at least 2 characters",
                                },
                              }}
                              value={formDataValues?.ques_behav || ""}
                              onChange={handleChange}
                            />
                            <div className="error">{errors.ques_behav}</div>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="vacancy_type_id"
                              className="col-form-label"
                            >
                              Position Level
                              <span className="text-danger">*</span>
                            </Label>
                            <Select
                              className="mb-2"
                              placeholder="Select Type"
                              id="vacancy_type_id"
                              name="vacancy_type_id"
                              validate={{ required: { value: true } }}
                              options={vacancyType}
                              onChange={e =>
                                handleChangeVacancyTypeValuePopulate(e)
                              }
                            />
                            <div className="error">
                              {errors.vacancy_type_id}
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label htmlFor="good" className="col-form-label">
                              Good
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="good"
                              name="good"
                              placeholder="Good"
                              errorMessage="Good Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Good Behaviour is required",
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage:
                                    "Good Behaviour must be at least 2 characters",
                                },
                              }}
                              style={{ height: "100px" }}
                              value={formDataValues?.good || ""}
                              onChange={handleChange}
                            />
                            <div className="error">{errors.good}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label htmlFor="average" className="col-form-label">
                              Average
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="average"
                              name="average"
                              placeholder="Average"
                              errorMessage="Average Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Average Behaviour is required",
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage:
                                    "Average Behaviour must be at least 2 characters",
                                },
                              }}
                              style={{ height: "100px" }}
                              value={formDataValues?.average || ""}
                              onChange={handleChange}
                            />
                            <div className="error">{errors.average}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label htmlFor="average" className="col-form-label">
                              Poor
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="poor"
                              name="poor"
                              placeholder="Poor"
                              errorMessage="Poor Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Poor Behaviour is required",
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage:
                                    "Poor Behaviour must be at least 2 characters",
                                },
                              }}
                              style={{ height: "100px" }}
                              value={formDataValues?.poor || ""}
                              onChange={handleChange}
                            />
                            <div className="error">{errors.poor}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label className="col-form-label">
                              Status<span className="text-danger">*</span>
                            </Label>
                            <Select
                              className="mb-2"
                              placeholder="Select Status"
                              id="status_id"
                              name="status"
                              validate={{ required: { value: true } }}
                              options={status}
                              onChange={e => handleChangeStatusValuePopulate(e)}
                            />
                            <div className="error">{errors.status}</div>
                          </FormGroup>
                        </Col>

                        <div className="cta text-center d-flex justify-content-center gap-2 mt-4 mb-4">
                          <Button
                            type="button"
                            className="btn btn-secondary"
                            onClick={e => {
                              e.preventDefault();
                              window.location.href = "/question-behaviour-list";
                            }}
                          >
                            {" "}
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            className="btn btn-primary"
                            color="success"
                          >
                            Submit
                          </Button>
                        </div>
                      </Row>
                    </div>
                  </div>
                </AvForm>
              </Col>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CreateQuestionBehaviour;
